export const API_BASE_URL = `https://bookedu.in/ibs/ibs2`;
// export const API_BASE_URL = `http://192.168.6.93:5000/ibs2`;
// export const API_BASE_URL = `http://192.168.6.84:5000/ibs2`;

// export const API_BASE_URL =  `${window.location.protocol}//${window.location.hostname}/ibs2`;
//   (process.env.NODE_ENV === "development" && "http://192.168.6.79:5000/ibs") ||



export const USER_ROLES = {
  CUSTOMER: "customer",
  VENDOR: "vendor",
  DELIVERY_PARTNER: "delivery_partner",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
};

export const ORDER_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  SHIPPED: "shipped",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
};

export const PRODUCT_CATEGORIES = [
  "fruits",
  "vegetables",
  "dairy",
  "meat",
  "bakery",
  "beverages",
  "organic",
  "frozen",
];
